export default "__VITE_ASSET__CbE0ekYt__"